export enum DirectionEnum {
    ASC = "asc",
    DESC = "desc"
}